// extracted by mini-css-extract-plugin
export default {"about":"styles_about__M+gFh","iconsList":"styles_iconsList__gooEU","icon":"styles_icon__Ql7J3"};